module.exports = __webpack_public_path__ + "static/tanoto-case-study-1068aded539d47770198659447b98e60.webp";